import axios from 'axios';
import LazyLoadingImage from './LazyLoadingImage';
import Overlay from './Overlay';
import CartHint from './CartHint';
import Quickview from './Quickview';

export default class ContentLoader {

  constructor(el) {

    this.loaded = false;
    this.wrapper = el;
    const range = document.createRange();
    this._ccfSupported = ('createContextualFragment' in range);
    this.url = this.wrapper.getAttribute('data-content-url');
    if (document.readyState == 'complete') {

      this.loadContent();
    } else {

      const loadContent = this.loadContent.bind(this);
      window.addEventListener('load', loadContent, false);
    }
  }

  loadContent() {

    if (this.loaded) {

      return;
    }

    axios.get(this.url, {
      headers: {
        'X-Requested-With': 'XMLHttpRequest'
      }
    })
    .then(res => {

      this.loaded = true;
      if (this._ccfSupported) {

        const fragment = document.createRange().createContextualFragment(res.data);
        const container = this.wrapper.parentNode;
        container.replaceChild(fragment, this.wrapper);
        window.responsiveImagesManager.setup(container);
      } else {

        this.wrapper.outerHTML = res.data;
        window.responsiveImagesManager.setup(this.wrapper);
      }
      window.taikoComponent.reloadModule(LazyLoadingImage, '.tc-lazy-loading-image');
      window.taikoComponent.reloadModule(CartHint, '.tc-add-to-cart');
      window.taikoComponent.reloadModule(Overlay, '.tc-overlay,.tc-quickview-button');
      window.taikoComponent.reloadModule(Quickview, '.tc-quickview');
    })
    .catch(error => {

      // this.wrapper.innerHTML = 'Error loading content';
      window.console.log('Error loading content: ' + error);
      this.wrapper.classList.add('has-error');

      throw `ContentLoader.js, axios fetch failed: ${error.message} in ${error.fileName}:${error.LineNumber}`;
    });
  }
}
